import { Modal, Button } from "react-bootstrap";

export default function DeleteModal({ show, onHide }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body className="text-center">
        <h5>Are you sure?</h5>
        <p>You want to delete this invoice</p>

        <Button variant="light" onClick={onHide}>
          Cancel
        </Button>
        <Button className="ms-2" variant="danger">
          Delete
        </Button>
      </Modal.Body>
    </Modal>
  );
}